import { render, staticRenderFns } from "./Calculations.vue?vue&type=template&id=3be6570c"
import script from "./Calculations.vue?vue&type=script&lang=js"
export * from "./Calculations.vue?vue&type=script&lang=js"
import style0 from "./Calculations.vue?vue&type=style&index=0&id=3be6570c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports